export class LocationEntity {
  /**
   * @param {{ country: string, locality: string, street: string, streetNumber: string }} location
   */
  constructor(location) {
    if (location) {
      for (let [key, value] of Object.entries(location)) {
        this[key] = value;
      }
    }
  }

  /**
   * @returns {string}
   */
  getFullAddress() {
    if (!this?.country && !this?.locality && !this?.street && !this?.streetNumber) return '';
    return `${this?.country || ''} ${this?.locality || ''} ${this?.street || ''} ${this?.streetNumber || ''}`;
  }

  /**
   * @returns {string}
   */
  getShortAddress() {
    if (!this?.country && !this?.locality) return '';
    return `${this?.country || ''} ${this?.locality || ''}`;
  }

  /**
   * @returns {string}
   */
  getFullStreetAddress() {
    if (!this?.street && !this?.streetNumber) return '';
    return `${this?.street || ''} ${this?.streetNumber || ''}`;
  }

  /**
   * @returns {string}
   */
  getCountry() {
    return this?.country || '';
  }

  /**
   * @returns {string}
   */
  getLocality() {
    return this?.locality || '';
  }
}
